import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { SectionIconContainerService } from './section-icon-container.service';
import { Section } from '@fcp/lib-ui';

@Component({
  selector: 'fcp-section-icon-container',
  template: `
    <fcp-section-icon
      [section]="data | async"
      (wasClicked)="wasClicked.emit($event)"
    ></fcp-section-icon>
  `
})
export class SectionIconContainerComponent implements OnInit {
  @Input() public id: string;
  @Output() public wasClicked: EventEmitter<any> = new EventEmitter();
  public data: Observable<Section>;
  constructor(private sectionIconContainerService: SectionIconContainerService) {}

  ngOnInit() {
    this.data = this.sectionIconContainerService.getSecao(this.id);
  }
}
